import { luxToDusk } from "./chain-config.js";

/**
 * Inline "N [dusk-mark]" amount - replaces plaintext "N DUSK" wherever an
 * amount is shown to the user; the mark stands in for the word "DUSK".
 * Pass raw lux (default) or an already-converted dusk number via `unit: "dusk"`.
 */
export function duskAmountNode(value, { unit = "lux", decimals } = {}) {
  const dusk = unit === "dusk" ? Number(value) || 0 : luxToDusk(value);
  const text = decimals != null ? dusk.toFixed(decimals) : String(dusk);

  const span = document.createElement("span");
  span.className = "dusk-amount";

  const amount = document.createElement("span");
  amount.className = "dusk-amount-value";
  amount.textContent = text;

  const mark = document.createElement("span");
  mark.className = "dusk-amount-mark";
  mark.setAttribute("role", "img");
  mark.setAttribute("aria-label", "DUSK");

  span.append(amount, mark);
  return span;
}
